import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {getFilteredZeitStarted} from '@src/app/pages/auswertungen/store/actions/filter-seek-date.actions';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {Observable} from 'rxjs';
import {MitarbeiterItem} from '@src/app/pages/Mitarbeiterverwaltung/mitarbeiter.model';
import {State} from '@src/app/pages/Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
import {loadAllMitarbeiterStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getAllMitarbeiter.actions';
import {ProjektState} from '@src/app/pages/projektverwaltung/store/reducer/projektverwaltung.reducer';

export interface DialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-auswertungenferien-form',
  templateUrl: './auswertungenferien-form.component.html',
  styleUrls: ['./auswertungenferien-form.component.scss']
})
export class AuswertungFerienFormComponent implements OnInit {


  constructor(public dialogRef: MatDialogRef<AuswertungFerienFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private mitarbeiter: Store<{ mitarbeiterverwaltung: State }>,
              private store: Store<{ projektverwaltung: ProjektState }>
              ) {
    this.$mitarbeiter = mitarbeiter.pipe(select((state) => state.mitarbeiterverwaltung.items));
  }

  public ferienAuswertungForm = new FormGroup({
    jahr: new FormControl(new Date().getFullYear(), [Validators.required, Validators.min(1000), Validators.max(9999)]),
    mitarbeiter: new FormControl('')
  });

  public allSelected = false;
  @ViewChild('mySel') private skillSel: MatSelect;
  public $mitarbeiter: Observable<MitarbeiterItem[]>;
  // tslint:disable-next-line:variable-name
  public last_selection = null;

  ngOnInit(): void {
    this.store.dispatch(loadAllMitarbeiterStart({string: sessionStorage.getItem('firmaId')}));
  }

  public okHandleClick(): void {
    // this.store.dispatch(getFilteredZeitStarted({item: this.auswertungForm.value }));
    this.dialogRef.close(this.ferienAuswertungForm.value);
  }

  public handleCancelClick(): void {
    this.dialogRef.close();
  }

  toggleAllSelection(): void {
    this.allSelected = !this.allSelected;  // to control select-unselect

    if (this.allSelected) {
      this.skillSel.options.forEach( (item: MatOption) => { item.select(); });
    } else {
      this.skillSel.options.forEach( (item: MatOption) => {item.deselect(); });
    }
  }

  okClicked(): void {
    this.last_selection = this.ferienAuswertungForm.controls.mitarbeiter.value;
    this.skillSel.close();
  }

}
